import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import SelectedMembers from "./SelectedMembers";
import UnselectedMembers from "./UnselectedMembers";
import ColorPicker from "../../../../parts/inputs/color-picker";
import { parseAthletesOrganizationInfoToClientList } from "../../../../utils/user-helpers";

const ManageGroupModal = ({
  originalGroupName,
  locals,
  isAllowToViewAllOrganizationsAthletes,
}) => {
  const { activeUser, query, allAthletesFromOrganization } = locals;
  const { filterGroup } = query;
  const [state, setState] = useState({
    name: "",
    description: "",
    selected: [],
    athletelist: [],
    showUnselectedMemberForMobile: false, //this is mostly for mobile, if showUnselectedMemberForMobile is true we have to show the component to select or unselect the members for mobile in the whole screen
  });

  useEffect(() => {
    // Logic for athletes
    let selectedAthletes = [];
    let allAthletes = [];

    const athletesToRequest =
      activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      allAthletesFromOrganization &&
      allAthletesFromOrganization.length
        ? parseAthletesOrganizationInfoToClientList(allAthletesFromOrganization)
        : activeUser.athletes;

    athletesToRequest
      .filter(({ status }) => !status?.inactive)
      .forEach((athlete) => {
        if (athlete.groups && athlete.groups.includes(filterGroup)) {
          selectedAthletes.push({ ...athlete, selected: true });
          allAthletes.push({ ...athlete, selected: true });
        } else {
          allAthletes.push({ ...athlete, selected: false });
        }
      });

    let updatedState = {
      ...state,
      selected: selectedAthletes,
      athletelist: allAthletes,
    };

    // Logic for athlete groups
    if (originalGroupName) {
      const athleteGroup = activeUser.athletesGroups.find(
        (elem) => elem.name === originalGroupName
      );
      if (athleteGroup) {
        updatedState = {
          ...updatedState,
          name: athleteGroup.name || "",
          color: athleteGroup.color || "",
          description: athleteGroup.description || "",
        };
      }
    }

    // Update state
    setState(updatedState);
  }, [activeUser, filterGroup, originalGroupName]);

  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const toggleShowUnselectedMemberForMobile = () => {
    setState({
      ...state,
      showUnselectedMemberForMobile: !state.showUnselectedMemberForMobile,
    });
  };

  const toggleAthlete = (index, fromSelected = true) => {
    let newSelected = [...state.selected];
    let newAthleteList = [...state.athletelist];

    if (fromSelected) {
      newAthleteList.forEach((elem) => {
        if (elem._id === newSelected[index]._id) {
          elem.selected = false;
        }
      });

      newSelected.splice(index, 1);
    } else {
      newSelected.push(newAthleteList[index]);
      newAthleteList.forEach((elem) => {
        if (elem._id === newAthleteList[index]._id) {
          elem.selected = true;
        }
      });
    }

    setState({
      ...state,
      selected: newSelected,
      athletelist: newAthleteList,
    });
  };

  const handleSubmit = () => {
    originalGroupName ? handleSubmitUpdate() : handleCreateGroup();
  };
  const handleCreateGroup = () => {
    const { name, description, selected } = state;
    submit(`/coaching-portal/athletes/new-group`, {
      method: "POST",
      body: {
        name,
        description,
        selected,
      },
    });
  };
  const handleSubmitUpdate = () => {
    const { name, description, selected } = state;

    const endpoint =
      activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      allAthletesFromOrganization &&
      allAthletesFromOrganization.length
        ? `/coaching-portal/athletes/organization-update-group`
        : `/coaching-portal/athletes/update-group`;

    const parseSelected = selected.map((obj) => {
      delete obj.selected;
      return obj;
    });

    submit(endpoint, {
      method: "POST",
      body: {
        originalGroupName,
        name,
        description,
        selected: parseSelected,
      },
    });
  };

  return (
    <Modal
      className={"manage-group"}
      title={query.modal.type === "new-group" ? "Add Group" : "Manage Group"}
    >
      {!state.showUnselectedMemberForMobile ? (
        <div className="body">
          <form>
            <div>
              <label>Name of group:</label>
              <input
                name="name"
                type="text"
                value={state.name}
                onChange={handleInputChange}
                placeholder="Enter a name for your group"
                autocomplete="off"
              />
            </div>
            <div>
              <label>Description of group:</label>
              <textarea
                name="description"
                type="text"
                value={state.description}
                onChange={handleInputChange}
                placeholder="Enter a description for your group"
              />
            </div>
          </form>
          <SelectedMembers
            athletes={state.selected}
            toggleAthlete={toggleAthlete}
            toggleShowUnselectedMemberForMobile={
              toggleShowUnselectedMemberForMobile
            }
            theme={activeUser.webAppTheme}
          />
          <UnselectedMembers
            classNames="mobile-hidden unselected"
            athletes={state.athletelist}
            toggleAthlete={toggleAthlete}
            referAsClients={activeUser.referAsClients}
            theme={activeUser.webAppTheme}
          />
        </div>
      ) : (
        <div className="body">
          <div
            className="back-select-members force-only-show-mobile"
            onClick={toggleShowUnselectedMemberForMobile}
          >
            <img src="/img/new-icons/arrow-left.svg" alt="back" />
            <span>Back</span>
          </div>
          <UnselectedMembers
            selectedAthletesForMobile={state.selected}
            classNames="only-show-mobile"
            athletes={state.athletelist}
            toggleAthlete={toggleAthlete}
            referAsClients={activeUser.referAsClients}
          />
        </div>
      )}

      <footer>
        <a
          role="button"
          data-icon
          data-button-type={"secondary"}
          data-action="cancel"
          href={`/actions/refresh?modal=`}
        >
          Cancel
        </a>
        <button data-button-type={"primary"} onClick={handleSubmit}>
          Save
        </button>
      </footer>
    </Modal>
  );
};

export default ManageGroupModal;
